// These values are part of the existing API contract. Labels may change in the
// UI, but persisted response values must remain stable for existing cycles.
export const PULSE_SCALE = [
  {key: 'drained', responseValue: 'drained', label: 'Overwhelmed', emoji: '😫'},
  {key: 'sad', responseValue: 'sad', label: 'Stretched', emoji: '😞'},
  {key: 'meh', responseValue: 'meh!', label: 'Managing', emoji: '😐'},
  {key: 'happy', responseValue: 'happy', label: 'Good', emoji: '🙂'},
  {key: 'elated', responseValue: 'elated', label: 'Great', emoji: '😁'},
] as const;

export type PulseScaleOption = typeof PULSE_SCALE[number];

export const DEFAULT_PULSE_VALUES = PULSE_SCALE.map(
  ({responseValue}) => responseValue,
);
export const DEFAULT_PULSE_EMOJIS = PULSE_SCALE.map(({emoji}) => emoji);

const normalizedValue = (value?: string | null) =>
  (value || '').trim().toLowerCase();

export const getPulseScaleOption = (value?: string | null) => {
  const normalized = normalizedValue(value);
  if (!normalized) return undefined;
  return PULSE_SCALE.find(
    (option) =>
      option.responseValue === normalized || option.key === normalized,
  );
};

export const pulseValuesMatch = (
  first?: string | null,
  second?: string | null,
) => {
  const normalizedFirst = normalizedValue(first);
  const normalizedSecond = normalizedValue(second);
  if (!normalizedFirst || !normalizedSecond) return false;
  return (
    (getPulseScaleOption(first)?.responseValue || normalizedFirst) ===
    (getPulseScaleOption(second)?.responseValue || normalizedSecond)
  );
};

// Unknown values keep their stored wording. Guessing a label by array position
// would silently misrepresent a new or custom scale as the legacy scale.
export const pulseLabelForValue = (value?: string | null) =>
  getPulseScaleOption(value)?.label || value?.trim() || 'Unknown response';
